export const REMOVE_ALERT_REQUEST = 'REMOVE_ALERT_REQUEST';
export const REMOVE_ALERT_SUCCESS = 'REMOVE_ALERT_SUCCESS';
export const REMOVE_ALERT_ERROR = 'REMOVE_ALERT_ERROR';

export const RESTORE_ALERT_REQUEST = 'RESTORE_ALERT_REQUEST';
export const RESTORE_ALERT_SUCCESS = 'RESTORE_ALERT_SUCCESS';
export const RESTORE_ALERT_ERROR = 'RESTORE_ALERT_ERROR';

export const CREATE_ALERT_REQUEST = 'CREATE_ALERT_REQUEST';
export const CREATE_ALERT_SUCCESS = 'CREATE_ALERT_SUCCESS';
export const CREATE_ALERT_FAILED = 'CREATE_ALERT_FAILED';

export const SORT_ALERTS = 'SORT_ALERTS';

export const OPEN_ALERTS = 'OPEN_ALERTS';
export const CLOSE_ALERTS = 'CLOSE_ALERTS';

const createAlertRequest = (data, onSuccess) => ({
  type: CREATE_ALERT_REQUEST,
  data,
  onSuccess,
});

const createAlertSuccess = (id, productId) => ({
  type: CREATE_ALERT_SUCCESS,
  id,
  productId,
});

const createAlertFailed = error => ({
  type: CREATE_ALERT_FAILED,
  error,
});

const removeAlertRequest = (id, productId, onSuccess) => ({
  type: REMOVE_ALERT_REQUEST,
  id,
  productId,
  onSuccess,
});

const removeAlertSuccess = (restoreToken, id, productId) => ({
  type: REMOVE_ALERT_SUCCESS,
  restoreToken,
  id,
  productId,
});

const restoreAlertRequest = (restoreToken, id, productId) => ({
  type: RESTORE_ALERT_REQUEST,
  restoreToken,
  id,
  productId,
});

const restoreAlertSuccess = (id, restoreToken) => ({
  type: RESTORE_ALERT_SUCCESS,
  id,
  restoreToken,
});

const restoreAlertError = error => ({
  type: RESTORE_ALERT_ERROR,
  error,
});

const removeAlertError = error => ({
  type: REMOVE_ALERT_ERROR,
  error,
});

const sortAlerts = sort => ({
  type: SORT_ALERTS,
  sort,
});

const openAlerts = () => ({
  type: OPEN_ALERTS,
  open: true,
});

const closeAlerts = () => ({
  type: CLOSE_ALERTS,
  open: false,
});

export default {
  createAlertRequest,
  createAlertSuccess,
  createAlertFailed,

  removeAlertRequest,
  removeAlertSuccess,
  removeAlertError,

  restoreAlertRequest,
  restoreAlertSuccess,
  restoreAlertError,

  sortAlerts,

  openAlerts,
  closeAlerts,
};
